import { useEffect } from 'react';
import { useBreadcrumbStore, type PrimesBreadcrumbContext } from '../stores/breadcrumbStore';

export const usePrimesBreadcrumbContext = (context: PrimesBreadcrumbContext | null): void => {
  const setPrimesContext = useBreadcrumbStore((state) => state.setPrimesContext);

  useEffect(() => {
    setPrimesContext(context);
    return () => setPrimesContext(null);
  }, [context, setPrimesContext]);
};
